import React from 'react';
import './input-custom.css';
import { ShopCategoriesType } from '../../../types/shopCategories';

interface ActionsColumnProps {
  record: ShopCategoriesType;
  onChangeInput: Function;
  onFocusNewRow: Function;
}

export const InputTitle = (props: ActionsColumnProps) => {
  const { record, onChangeInput, onFocusNewRow } = props;
  const title = record?.title || '';
  const isBlock = !!record.id && !record.isInEditMode;

  return (
    <div className="add-video-container">
      <input
        type="text"
        placeholder="Title"
        value={title}
        onChange={event => {
          onChangeInput(event);
        }}
        disabled={isBlock}
        className="title-input"
        onFocus={e => {
          if (!record?.id && !record?.title && !record?.ctaLink) {
            onFocusNewRow(e);
          }
        }}
        draggable
        onDragStart={event => event.preventDefault()}
      />
    </div>
  );
};
